import React from 'react'

import { string } from 'prop-types'

import { REGULAR_EARNINGS_PANEL_CONFIG } from '../../../Static/earningsDetailConfig'

function RegularEarningsEmptyState({
  title = REGULAR_EARNINGS_PANEL_CONFIG.emptyState.sales.title,
  description = REGULAR_EARNINGS_PANEL_CONFIG.emptyState.sales.description,
}) {
  return (
    <div
      className="regular-earnings-detail-panel__empty-state"
      role="status"
      aria-live="polite"
    >
      <h3 className="regular-earnings-detail-panel__empty-state-title cgt-heading-400">
        {title}
      </h3>
      <p className="regular-earnings-detail-panel__empty-state-description cgt-body-base">
        {description}
      </p>
    </div>
  )
}

RegularEarningsEmptyState.propTypes = {
  title: string,
  description: string,
}

export default RegularEarningsEmptyState
